import { render } from "./ViewAttachmentsIframeDialog.vue?vue&type=template&id=a9a91c06&scoped=true"
import script from "./ViewAttachmentsIframeDialog.vue?vue&type=script&lang=js"
export * from "./ViewAttachmentsIframeDialog.vue?vue&type=script&lang=js"

import "./ViewAttachmentsIframeDialog.vue?vue&type=style&index=0&id=a9a91c06&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9a91c06"]])

export default __exports__